// Gavion deal pipeline defaults (spec 09 §1). The live stages are configured (config.dealStages): read them through
// stageModel.ts. DEAL_STAGE_VALUES / STAGE_LABELS_FR are the defaults' values and French labels (i18n).
import { DEFAULT_DEAL_STAGES, type StageDef } from "./stageModel";

export const DEAL_STAGE_VALUES = [
  "nouveau_lead",
  "qualifie",
  "proposition_envoyee",
  "negociation",
  "gagne",
  "perdu",
] as const;
export type DealStageValue = (typeof DEAL_STAGE_VALUES)[number];
export type { StageKind } from "./stageModel";

export const STAGE_LABELS_FR: Readonly<Record<DealStageValue, string>> = {
  nouveau_lead: "Nouveau lead",
  qualifie: "Qualifié",
  proposition_envoyee: "Proposition envoyée",
  negociation: "Négociation",
  gagne: "Gagné",
  perdu: "Perdu",
};
/** The default config.dealStages (with colours and probabilities); the screens read the configured ones. */
export const GAVION_DEAL_STAGES: StageDef[] = DEFAULT_DEAL_STAGES.map((s) => ({
  ...s,
}));
export const GAVION_PIPELINE_STATUSES = ["gagne"];

export const DEAL_CATEGORY_LABELS_FR = {
  gala_receptionniste: "Gala Réceptionniste",
  gala_administration: "Gala Administration",
  site_web: "Site web",
  automatisation: "Automatisation",
  autre: "Autre",
} as const;
export const GAVION_DEAL_CATEGORIES = Object.entries(
  DEAL_CATEGORY_LABELS_FR,
).map(([value, label]) => ({ value, label }));

export const LOSS_REASONS = [
  "prix",
  "deja_fournisseur",
  "pas_le_bon_moment",
  "pas_de_reponse",
  "pas_le_decideur",
  "produit_ne_convient_pas",
  "autre",
] as const;
export type LossReason = (typeof LOSS_REASONS)[number];
export const LOSS_REASON_LABELS_FR: Readonly<Record<LossReason, string>> = {
  prix: "Prix",
  deja_fournisseur: "Déjà un fournisseur",
  pas_le_bon_moment: "Pas le bon moment",
  pas_de_reponse: "Pas de réponse / fantôme",
  pas_le_decideur: "Pas le décideur",
  produit_ne_convient_pas: "Produit ne convient pas",
  autre: "Autre",
};

export const DEAL_SOURCES = [
  "cold_call",
  "organic",
  "gala",
  "referral",
  "other",
] as const;
export type DealSource = (typeof DEAL_SOURCES)[number];
export const DEAL_SOURCE_LABELS_FR: Readonly<Record<DealSource, string>> = {
  cold_call: "Appel à froid",
  organic: "Organique",
  gala: "Gala",
  referral: "Référence",
  other: "Autre",
};

/** Only https Teams meeting links are rendered as a join button (no javascript:/data: URLs). */
export const isTeamsJoinUrl = (url: string | null | undefined): boolean =>
  typeof url === "string" &&
  /^https:\/\/teams\.(microsoft|live)\.com\//i.test(url);
